import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table,Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import EyeIcon from 'mdi-react/EyeIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderFileInputField from '../../../../shared/components/form/FileInput';
import renderSelectField from '../../../../shared/components/form/Select';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import $ from 'jquery';
import readXlsxFile from 'read-excel-file';
import XLSX from 'xlsx';
import { make_cols } from './MakeColumns';
import { SheetJSFT } from './types';
import Sheet from '../../../../images/BIN_MASTER_v1.xlsx';
import Select from 'react-select';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
/*import Modal from '../../../../shared/components/Modal';*/
import styled, { css } from "styled-components";

const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  ${(props) =>
    props.disappear &&
    css`
      display: block; /* show */
    `}
`;


/*const data = {
    columns: [
      {
        label: 'Bin ID',
        field: 'bin_id',
        width: 150
      },
      {
        label: 'Storage Type',
        field: 'storage_type',
        width: 270
      },
      
      {
        label: 'Aisle',
        field: 'aisle',
        width: 100
      },
      {
        label: 'Rack',
        field: 'rack',
        width: 270
      },
      
      {
        label: 'Rack Type',
        field: 'rack_type',
        width: 270
      },
      {
        label: 'Level',
        field: 'level',
        width: 270
      },
      {
        label: 'Zone Name',
        field: 'zone_name',
        width: 270
      },
      {
        label: 'Zone No.',
        field: 'zone_number',
        width: 270
      }
      
    ],
    rows: [
      {
        name: 'Tiger Nixon',
        position: 'System Architect',
        office: 'Edinburgh',
        office: 'Edinburgh',
        office: 'Edinburgh',
        office: 'Edinburgh',
        office: 'Edinburgh',
        office: 'Edinburgh'
        
      },
      
      
      
      
      
      {
        bin_id: 'Donna Snider',
        position: 'Customer Support',
        office: 'New York',
        office: 'New York',
        office: 'New York',
        level: '',
        zone_name: 'ABCD',
        zone_number: 'Abc',
      }
    ]
  }
*/

var url =  window.location.hostname;
var port = window.location.port;

const options = [
  { value: 'chocolate', label: 'Chocolate' },
  { value: 'strawberry', label: 'Strawberry' },
  { value: 'vanilla', label: 'Vanilla' },
];


const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';


 const exportToCSV = (csvData, fileName) => {
    // const ws = XLSX.utils.json_to_sheet(csvData);
    const Heading = [['Basepack Code'	,'Basepack Desc',	'Category',	'Storage Type'	,'Shade Applicable',	'Shade Code',	'Shade Name',	'Company',	',Brand',	'Sub Brand', 'Fast Moving',	'Shelf Life',	'Barcode Type',	'OCLD Flag',	'Added On',	'Updated On',	'Created By',	'Updated By',	'OCLD FlagUpdated time',	'Invoicing Shelf Life']]
    const ws = XLSX.utils.json_to_sheet(csvData,{ origin: 'A2', skipHeader: true });
    XLSX.utils.sheet_add_aoa(ws, Heading, { origin: 'A1' });
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {type: fileType});
    FileSaver.saveAs(data, fileName + fileExtension);
  }



class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  


  constructor() {
   super();
   this.handleChange = this.handleChange.bind(this);
   this.handleFile = this.handleFile.bind(this);
   
  this.accessCookie = this.accessCookie.bind(this);
   this.change = this.change.bind(this);
   this.fetchBinData = this.fetchBinData.bind(this);
   this.toggle = this.toggle.bind(this);
   this.toggleFailed = this.toggleFailed.bind(this);
   this.indexOfExt = this.indexOfExt.bind(this);
   this.processData = this.processData.bind(this);
   this.togglePressCancel = this.togglePressCancel.bind(this);
   this.Successtoggle = this.Successtoggle.bind(this);
   this.SuccesstoggleCancel = this.SuccesstoggleCancel.bind(this);
   this.ConfirmToggle = this.ConfirmToggle.bind(this);
   this.openConfirm = this.openConfirm.bind(this);

   /*this.onMasterChange = this.onMasterChange.bind(this);*/

    this.state = {
	  loading_overlay: false,	
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      loadingGRNData: false,
      showInvalidBaseItem:false,
      showInvalidProductItem:false,
      fileNameVal: 'masterFile',
      showResponseData: false,
      showBaseResponseData: false,
      showProductResponseData: false,
      responseUpdatedBaseData: false,
      responseUpdatedProductData: false,
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      postsBase: [],
      postsProduct: [],
      postsTester: [],
      tableRowsBase: [],
      tableRowsProduct: [],
      tableRowsTester: [],
      ErrorRowData: [],
      modal: false,
      modalFailed: false,
      ConfirmModal: false,
      Successmodal: false,
      loading: false,

      isLoading:true,
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      show_process_data: true,

      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
      BinMasters:["Aisle","Bin", "Bin Address" , "Level" , "Rack" , "Rack Type" , "Storage Type" , "Zone Name" , "Zone No."],
      /*BasePackCodes:["Base Pack Code" , "Zone Name" , "Zone No"],*/

      BasePackCodes:[{"Base Pack Code": "fghj" , "Zone Name": "fghj" , "Zone No": "fghj"}],

      validation: {
        "Bin Master": {
          "Aisle": "string",
          "Bin": "number",
          "Bin Address": "string",
          "Level": "number",
          "Rack": "number",
          "Rack type": "string",
          "Storage type": "string",
          "Zone Name": "string",
          "Zone No.": "number",
        },

        "Basepack Zone": {
          "Base Pack Code": "string",
          "Zone Name": "string",
          "Zone No.": "number",
        },

        "Product Master": {
          "Company": "string",
          "Brand": "number",
          "Sub Brand": "string",
          "LB SKU ID": "number",
          "LB SKU Product Name": "number",
          "Basepack Code": "string",
          "CBU Code": "string",
          "Shade Code": "string",
          "Shade Name": "number",
          "Category": "string",
          "Sub-Category": "string",
          "Price Lot": "string",
          "MRP": "string",
          "UOM": "string",
          "UPC": "string",
          "Pack Size": "string",
          "Pack Size UOM": "string",
          "EAN": "string",
          "ICLD EAN": "string",
          "Weight": "string",
          "Volume": "string",
          "ICLD Volume": "string",
          "SKU7 Code": "string",
          "SKU5 Code": "string",
          "Offer": "string",
          "Tester": "string",
          "Storage Type": "string",
          "Status": "string",
          "Created Date Time": "string",
          "Updated Date Time": "string",
        },

        "Tester Basepack Master": {
          "S. No.": "number",
          "BasePack Code": "string",
          "Basepack Description": "string",
          "Bin": "string",
          
          
        },


      }
    };
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

 

  /*onMasterChange(event){
    this.setState({
      value: event.target.value
    })
    console.log(this.state.value);

  }*/

  componentDidMount(){
  this.fetchBinData();
  }


  componentWillMount(){

      if (window.location.port == 8091 || window.location.port === ":8090") {
          port = ":8090"
        }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }else{
          port = ":8088"
        }

      if (url === "localhost") {
        url= "15.206.34.41"+":8088";

      }else{
        url= window.location.hostname+port;
      }

      var cookieUsername = this.getCookie('token');
      var location = this.getCookie('selectedLocation');
      var username = this.accessCookie("token");
      this.setState({
        userName: cookieUsername,
        selectedLocation: location
      })

      localStorage.setItem('userName' , username);
    }






   

  accessCookie(cookieName)
        {
          var name = cookieName + "=";
          var allCookieArray = document.cookie.split(';');
          for(var i=0; i<allCookieArray.length; i++)
          {
            var temp = allCookieArray[i].trim();
            if (temp.indexOf(name)==0)
            return temp.substring(name.length,temp.length);
         }
        return "";
        } 


        getCookie(cname) {
          var name = cname + "=";
          var decodedCookie = decodeURIComponent(document.cookie);
          var ca = decodedCookie.split(';');
          for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        }




  SuccesstoggleCancel(){
    this.setState({
        Successmodal: false
    })

    if (this.state.selectedOption.value === "bin_master") {
          this.fetchBinData();
          

      } else if (this.state.selectedOption.value === "base_pack_zone") {
          this.fetchBaseData();
          

      } else if (this.state.selectedOption.value === "product_master") {
          this.fetchProductData();
          

      }
  }

  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  Successtoggle() {
    this.setState(prevState => ({ Successmodal: !prevState.Successmodal }));
  }

  toggleFailed() {
    this.setState(prevState => ({ modalFailed: !prevState.modalFailed }));  
  }

  ConfirmToggle(){
    this.setState(prevState => ({ ConfirmModal: !prevState.ConfirmModal }));
  }

  openConfirm(){
    this.setState({
      ConfirmModal: true
    })

  }



  togglePressCancel(){

      if (this.state.selectedOption.value === "bin_master") {
          this.fetchBinData();
          this.setState({
            showFetchBinData: true,
            showFetchBaseData: false,
            showFetchProductData: false,
            showInvalidItem: true,
            showInvalidItemBase: false,
            showInvalidItemProduct: false,
            showInvalidTesterItem: false
            
          })

      } else if (this.state.selectedOption.value === "base_pack_zone") {
          this.fetchBaseData();
          this.setState({
            showFetchBinData: false,
            showFetchBaseData: true,
            showFetchProductData: false,
            showInvalidItem: false,
            showInvalidBaseItem: true,
            showInvalidProductItem: false,
            showInvalidTesterItem: false

          })

      } else if (this.state.selectedOption.value === "product_master") {
          this.fetchProductData();
          this.setState({
            showFetchBinData: false,
            showFetchBaseData: false,
            showFetchProductData: true,
            showInvalidItem: false,
            showInvalidBaseItem: false,
            showInvalidProductItem: true,
            showInvalidTesterItem: false
          })

      }else if (this.state.selectedOption.value === "tester_basepack_master") {
          this.fetchProductData();
          this.setState({
            showInvalidTesterItem: true,
            showFetchBinData: false,
            showFetchBaseData: false,
            showFetchProductData: false,
            showInvalidItem: false,
            showInvalidBaseItem: false,
            showInvalidProductItem: false,
            showFetchTesterData: true
            
          })

      }

      this.setState({
        modal: false,
        modalFailed: false,
      })

      

  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
        var keys = Object.keys(list[i]);
        var flg = true;
        for (var j = 0; j < keys.length; j++) {
            var value = list[i][keys[j]];
            if (item[keys[j]] !== value) {
                flg = false;
            }
        }
        if (flg == true) {
            return i;
        }
    }
    return -1;
}

  fetchBinData(){


      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchProductData: false,
        showFetchTesterData: false,
		    loading_overlay:true
      })


     const payload={}
API.get('/product/basepack_master/v1/view/', { param: payload })
          

      .then(response => response.data)

      .then(data => {

         console.log("Area Data",data);

         // if (err) throw err;

         this.setState({ loading_overlay:false,posts: data.data ,filtered_orderData : data.data})

      })

      .then(async() => {

         this.setState({ tableRows:this.assemblePosts(), isLoading:false })

         console.log(this.state.tableRows);

      });
  }
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.posts });
    } else {
      // var value = this.state.posts.filter(
      //   (val) =>
      //     val.base_pack_code.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.base_pack_desc.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.brand.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.invoicing_shelf_life.toString().includes(evt) 

      // );

      var value = this.state.posts.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );
      
      this.setState({
        filtered_orderData: value,
      });
    }
  };

  fetchBaseData(){


      this.setState({
        showFetchBaseData: true,
        showFetchBinData: false,
        showFetchProductData: false,
        showFetchTesterData: false

      })


      const payload={}
API.get('/inventory/base_pack_zone_code_master/v1/?location=', { param: payload })
      .then(response => response.data)

      .then(data => {

         // console.log(data);

         // if (err) throw err;

         this.setState({ postsBase: data })

      })

      .then(async() => {

         this.setState({ tableRowsBase:this.assemblePostsBase(), isLoading:false })

         console.log(this.state.tableRowsBase);

      });
  }

  fetchProductData(){


      this.setState({
        showFetchBaseData: false,
        showFetchBinData: false,
        showFetchProductData: true,
        showFetchTesterData: false,
        loadingGRNData: true,

      })


      const payload={}
API.get('/product/product_master/v1/?location=', { param: payload })
      .then(response => response.data)

      .then(data => {

         // console.log(data);

         // if (err) throw err;

         this.setState({ postsProduct: data })
         console.log(this.state.postsProduct);

      })

      .then(async() => {

         this.setState({ tableRowsProduct:this.assemblePostsProduct(), isLoading:false, loadingGRNData: false })

         console.log(this.state.tableRowsProduct);

      });
  }




  fetchTesterData(){


      this.setState({
        showFetchBaseData: false,
        showFetchBinData: false,
        showFetchProductData: false,
        showFetchTesterData: true,
        loadingGRNData: true,

      })


      const payload={}
API.get('/inventory/testerBasePackZoneUtility/v1/?location=', { param: payload })

      .then(response => response.data)

      .then(data => {

         console.log(data);

         // if (err) throw err;

         this.setState({ postsTester: data })
         console.log(this.state.postsProduct);

      })

      .then(async() => {

         this.setState({ tableRowsTester:this.assemblePostsTester(), isLoading:false, loadingGRNData: false })

         console.log(this.state.tableRowsTester);

      });
  }




  assemblePosts= () => {

    let posts =this.state.posts.map((post) => {

      return (

        {
          base_pack_code: post.base_pack_code,
          base_pack_desc: post.base_pack_desc,


          category: post.category,

          storage_type: post.storage_type,
          shade_applicable: post.shade_applicable,

          shade_code: post.shade_code,
          shade_name: post.shade_name,
          company: post.company,
          brand: post.brand,

          sub_brand: post.sub_brand,

          fast_moving: post.fast_moving,

          shelf_life: post.shelf_life,

          barcode_type: post.barcode_type,

          ocld_flag: post.ocld_flag,

          added_on: post.added_on,
          
          updated_on: post.updated_on,
          
          created_by: post.created_by,

          updated_by: post.updated_by,

          ocld_flag_update_time: post.ocld_flag_update_time,
          invoicing_shelf_life: post.invoicing_shelf_life


          






          

        }

      )

    });

    return posts;

  }


  assemblePostsBase= () => {

    let postsBase =this.state.postsBase.map((post) => {

      return (

        {

          base_pack_code: post.basePackCode,

          zone_name: post.zoneName,

          zone_number: post.zoneNo,
          productType: post.productType,

        }

      )

    });

    return postsBase;

  }


  assemblePostsProduct= () => {

    console.log(this.state.postsProduct);

    let postsProduct =this.state.postsProduct.map((post) => {

      return (

        {

          company: post.company,

          brand: post.brand,

          sub_brand: post.subBrand,

          ib_sku_id: post.lbSkuId,

          ib_sku_product_name: post.lbSkuProductName,

          base_pack_code: post.basepackCode,

          cbu_code: post.cbuCode,

          shade_code: post.shadeCode,

          shade_name: post.shadeName,

          category: post.category,

          sub_category: post.subCategory,

          price_lot: post.priceLot,

          mrp: post.mrp,

          uom: post.uom,

          upc: post.upc,

          pack_size: post.packSize,

          pack_size_uo: post.packSizeUom,

          ean: post.ean,

          icld_ean: post.icldEAN,
		  
		  product_length: post.productLength,  
		  
		  product_breadth: post.productBreadth,  
		  
		  product_height: post.productHeight,

          weight: post.weight,

          volume: post.volume,

          icldVolume: post.icldVolume,

          sku7Code: post.sku7Code,

          sku5Code: post.sku5Code,

          offer: post.offer,

          tester: post.tester,

          storageType: post.storageType,

          status: post.status,

          createdDateTime: post.createdDateTime,

          //updatedDateTime: post.updatedDateTime,
          outerCartonEAN: post.outerCartonEAN,
          cpo: post.cpo,
          cartonLength: post.cartonLength,
          cartonBreadth: post.cartonBreadth,
          cartonHeight: post.cartonHeight,
          cartonVolume: post.cartonVolume,
          ocldApplicable: post.ocldApplicable,

        }

      )

    });

    return postsProduct;

  }

   assemblePostsTester= () => {

    console.log(this.state.postsTester);

    let postsTester =this.state.postsTester.map((post) => {

      return (

        {


          base_pack_code: post.base_pack_code,
         
          bin: post.bin_address

         


        }

      )

    });

    return postsTester;

  }





  handleChange(evt) {
    const files = evt.target.files;
    if (files && files[0]) this.setState({ file: files[0] });
    var file1 = evt.target.value
    var fileArray1 = evt.target.value.split('.')
    var extension1 = fileArray1[fileArray1.length - 1]
    if(extension1 != 'xlsx' && extension1 != 'csv' && extension1 != 'xls'){
    
      $(".upload_error").css('display', 'block');
      $(".upload_success").css('display', 'none');
    }else {
      $(".upload_success").css('display', 'block');
      $(".upload_error").css('display', 'none');
      $('.button_enable').removeAttr('disabled','disabled');
    }
  };

  change = (selectedOption) => {
    this.setState({ selectedOption,
                  selectedFileType:selectedOption.label,
                  showInvalidProductItem: false,
                  showInvalidTesterItem: false,
                  showRowDataErrorProduct: false,
                  showRowDataErrorTester: false,
                  showInvalidBaseItem: false,
                  showRowDataErrorBase: false,
                  showRowDataError: false,
                  showInvalidItem: false,


     });
	 
	 return false;
      $(".upload_error").css('display', 'none');
      $(".upload_success").css('display', 'none');
      $(".fileControl").val('');


      if (selectedOption.value === "bin_master") {
          this.fetchBinData();
          this.setState({
            showFetchBinData: true,
            showFetchBaseData: false,
            showFetchTesterData: false,
            showFetchProductData: false
          })

      } else if (selectedOption.value === "base_pack_zone") {
          this.fetchBaseData();
          this.setState({
            showFetchBinData: false,
            showFetchBaseData: true,
            showFetchProductData: false,
            showFetchTesterData: false
          })

      } else if (selectedOption.value === "product_master") {
          this.fetchProductData();
          this.setState({
            showFetchBinData: false,
            showFetchBaseData: false,
            showFetchProductData: true,
            showFetchTesterData: false
          })

      } else if (selectedOption.value === "tester_basepack_master") {
          this.fetchTesterData();
          this.setState({
            showFetchBinData: false,
            showFetchBaseData: false,
            showFetchProductData: false,
            showFetchTesterData: true
          })

      }

    console.log(`Option selected:`, selectedOption.value);
  }

  submitClickHandler = () => {
     
      $(".upload_error").css('display', 'none');
      $(".upload_success").css('display', 'none');
      $(".fileControl").val('');


      if (this.state.selectedOption.value === "bin_master") {
          this.fetchBinData();
          this.setState({
            showFetchBinData: true,
            showFetchBaseData: false,
            showFetchTesterData: false,
            showFetchProductData: false
          })

      } else if (this.state.selectedOption.value === "base_pack_zone") {
          this.fetchBaseData();
          this.setState({
            showFetchBinData: false,
            showFetchBaseData: true,
            showFetchProductData: false,
            showFetchTesterData: false
          })

      } else if (this.state.selectedOption.value === "product_master") {
          this.fetchProductData();
          this.setState({
            showFetchBinData: false,
            showFetchBaseData: false,
            showFetchProductData: true,
            showFetchTesterData: false
          })

      } else if (this.state.selectedOption.value === "tester_basepack_master") {
          this.fetchTesterData();
          this.setState({
            showFetchBinData: false,
            showFetchBaseData: false,
            showFetchProductData: false,
            showFetchTesterData: true
          })

      }
 
    //console.log(`Option selected:`, selectedOption.value);
  }
  
  validateItem = item => {
    const { selectedFileType, validation } = this.state
    const dataTypes = validation[selectedFileType]
    const keyNames = Object.keys(dataTypes)
    if(Object.keys(item).length !== keyNames.length){
      this.setState({
        error: "Invalid length of uploaded data. Below data are invalid. Please Upload a valid file format"
      })
      return false
    }
    /*if(Object.keys(item).filter(key => (keyNames.indexOf(key) === -1)).length){
      this.setState({
        error: "Invalid header of data uploaded. Below data are invalid. Please Upload a valid file formate"
      })
      return false
    }
    if(Object.keys(item).filter(key => (typeof item[key] !== dataTypes[key])).length){
      this.setState({
        error: "Invalid datatype of data uploaded.Below data are invalid. Please Upload a valid file formate"
      })
      return false
    }*/
    return true
  }
 
  handleFile() {
    /* Boilerplate to set up FileReader */
    this.setState({
      loading: true
    })
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
 
    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA : true });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws,{raw:false,dateNf: 'YYYY-MM-DD'});

      

      /* Update state */
      this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {


        let invalidItems = this.state.data.filter(item => !this.validateItem(item))
        /*if(invalidItems.length > 0){

          console.log("Invalid Items", invalidItems)
          this.setState({
            showInvalidItem: true,
            showResponseData: true,
            invalidItemList: invalidItems

          })
        }else{
          console.log("Valid items");
           this.setState({
            showInvalidItem: false,

          })*/

          if (this.state.selectedOption.value==="base_pack_zone") {

            if(invalidItems.length > 0){
              console.log(invalidItems);
              this.setState({
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                showRowDataErrorTester: false,
                showRowDataError: false,
                showResponseData: true,
                ErrorRowData: invalidItems,
                showResponseData: false,
                showInvalidItem: false,
                showBaseResponseData: false,
                showInvalidBaseItem: false,
                showInvalidProductItem: false,
                showInvalidTesterItem: false,
                showProductResponseData: false,
                showFetchBaseData: false,
                showFetchProductData: false,
                showFetchTesterData: false,
                showFetchBinData: false


              })

              console.log(Object.keys(invalidItems));
              /*alert(indexOfExt(this.state.BasePackCodes, invalidItems));*/

              /*return false*/
            }
            

            console.log(this.state.data.length);
              var arr = []
    
          

          
          for(var i = 0; i < this.state.data.length; i++) {
               // <---- Move declaration inside loop
              
            var orderData  = {};
              orderData['basePackCode'] = this.state.data[i]['BasepackCode'];
              orderData['zoneName'] = this.state.data[i]['ZoneName'];
              orderData['zoneNo'] = this.state.data[i]['ZoneNo'];

              
              arr.push(orderData);
          }

          console.log(arr);
          var arr_data = JSON.stringify(arr)


          const payload = {
            arr_data: this.state.data,
            location: this.state.selectedLocation,
            create: false,
  };

API.post('/inventory/base_pack_zone_code_master/v1/', { param: payload })
            .then((response) =>  {

              console.log(response);
              this.setState({
                showBaseResponseData: true,
                showInvalidBaseItem: false,
                showInvalidTesterItem: false,
                showTesterResponseData: false,
                loading: false,
                showResponseData: false,
                showInvalidItem: false,
                showProductResponseData: false,
                showInvalidProductItem: false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                showRowDataErrorTester: false,
                responseFailBaseData: response.data,
                responseSuccessBaseData: response.data,

              })

              if (response.data.failure_response.length>0) {
                this.toggleFailed();
              }else{
                this.toggle();
              }

              if (response.data.success_response.length>0) {
                this.setState({
                  show_process_data: true
                })

              }else{
                this.setState({
                  show_process_data: false
                })
                 
              }
              
              /*this.fetchBaseData();*/

            })
            .catch(function (error) {
              
              
          });
          }


          if (this.state.selectedOption.value==="product_master") {


            if(invalidItems.length > 0){
              console.log(invalidItems);
              this.setState({
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                showRowDataErrorTester: false,
                showResponseData: true,
                ErrorRowData: invalidItems,
                showResponseData: false,
                showInvalidItem: false,
                showBaseResponseData: false,
                showTesterResponseData: false,
                showInvalidBaseItem: false,
                showInvalidProductItem: false,
                showInvalidTesterItem: false,
                showProductResponseData: false,
                showFetchBaseData: false,
                showFetchProductData: false,
                showFetchTesterData: false,
                showFetchBinData: false,
                showRowDataError: false

              })

              console.log(Object.keys(invalidItems));
             /* alert(indexOfExt(items, invalidItems));*/

              /*return false*/
            }


            console.log(this.state.data);
              var arr = []
    
          

          
          for(var i = 0; i < this.state.data.length; i++) {
               // <---- Move declaration inside loop
              
            var orderData  = {};
              orderData['company'] = this.state.data[i]['Company'];
              orderData['brand'] = this.state.data[i]['Brand'];
              orderData['subBrand'] = this.state.data[i]['Subbrand'];
              orderData['lbSkuId'] = this.state.data[i]['LBSKUID'];
              orderData['lbSkuProductName'] = this.state.data[i]['LBSKUProductName'];
              orderData['basepackCode'] = this.state.data[i]['BasepackCode'];
              orderData['cbuCode'] = this.state.data[i]['CBUCode'];
              orderData['shadeCode'] = this.state.data[i]['ShadeCode'];
              orderData['shadeName'] = this.state.data[i]['ShadeName'];
              orderData['category'] = this.state.data[i]['Category'];
              orderData['subCategory'] = this.state.data[i]['SubCategory'];
              orderData['priceLot'] = this.state.data[i]['PriceLot'];
              orderData['mrp'] = this.state.data[i]['MRP'];
              orderData['uom'] = this.state.data[i]['UOM'];
              orderData['upc'] = this.state.data[i]['UPC'];
              orderData['packSize'] = this.state.data[i]['PackSize'];
              orderData['packSizeUom'] = this.state.data[i]['PackSizeUOM'];
              orderData['ean'] = this.state.data[i]['EAN'];              
              orderData['icldEAN'] = this.state.data[i]['ICLD EAN'];
			  
			  orderData['weight'] = this.state.data[i]['Weight'];
              orderData['volume'] = this.state.data[i]['Volume'];
              orderData['icldVolume'] = this.state.data[i]['ICLD Volume'];
              orderData['sku7Code'] = this.state.data[i]['SKU7 Code'];
              orderData['sku5Code'] = this.state.data[i]['SKU5 Code'];
              orderData['offer'] = this.state.data[i]['Offer'];
              orderData['tester'] = this.state.data[i]['Tester'];
              orderData['storageType'] = this.state.data[i]['Storage Type'];
              orderData['status'] = this.state.data[i]['Status'];
              orderData['createdDateTime'] = this.state.data[i]['Created Date Time'];
              orderData['updatedDateTime'] = this.state.data[i]['Updated Date Time'];

              
              arr.push(orderData);
          }

          console.log(arr);
          var arr_data = JSON.stringify(arr)


          const payload = {
            arr_data: this.state.data,
            location: this.state.selectedLocation
  };

API.post('/product/product_master/v1/', { param: payload })
            .then((response) =>  {

              if (response.data.failure_response.length>0) {
                this.toggleFailed();
              }else{
                this.toggle();
              }

              if (response.data.success_response.length>0) {
                this.setState({
                  show_process_data: true
                })

              }else{
                this.setState({
                  show_process_data: false
                })
                 
              }

              console.log(response);
              this.setState({
                showBaseResponseData: false,
                showProductResponseData: true,
                loading: false,
                showInvalidBaseItem: false,
                showResponseData: false,
                showInvalidItem: false,
                showInvalidProductItem:false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                showRowDataErrorTester: false,
                showInvalidTesterItem: false,
                showTesterResponseData: false,
                responseFailProductData: response.data,
                responseSuccessProductData: response.data,
                
              })
              /*this.toggle();*/
              this.fetchProductData();

            })
            .catch(function (error) {
              
              
          });


              
          }



          if (this.state.selectedOption.value==="tester_basepack_master") {

            if(invalidItems.length > 0){
              console.log(invalidItems);
              this.setState({
                showRowDataErrorBase: false,
                showRowDataErrorTester: false,
                showRowDataErrorProduct: false,
                showRowDataError: false,
                showResponseData: false,
                ErrorRowData: invalidItems,
                showResponseData: false,
                showInvalidItem: false,
                showBaseResponseData: false,
                showInvalidBaseItem: false,
                showInvalidProductItem: false,
                showInvalidTesterItem: false,
                showFetchTesterData: false,
                showTesterResponseData: false,
                showProductResponseData: false,
                showFetchBaseData: false,
                showFetchProductData: false,
                showFetchBinData: false


              })

              console.log(Object.keys(invalidItems));
              /*alert(indexOfExt(this.state.BasePackCodes, invalidItems));*/

              /*return false*/
            }
            

            console.log(this.state.data.length);


          const payload = {
            arr_data: this.state.data,
            location: this.state.selectedLocation,
            create: false,
  };

API.post('/inventory/testerBasePackZoneUtility/v1/', { param: payload })
            .then((response) =>  {

              console.log(response);
              this.setState({
                showBaseResponseData: false,
                showTesterResponseData: true,
                showInvalidBaseItem: false,
                loading: false,
                showResponseData: false,
                showInvalidItem: false,
                showProductResponseData: false,
                showInvalidProductItem: false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                showRowDataErrorTester: false,
                showInvalidTesterItem: false,
                responseFailTesterData: response.data,
                responseSuccessTesterData: response.data,

              })

              if (response.data.failure_response.length>0) {
                this.toggleFailed();
              }else{
                this.toggle();
              }

              if (response.data.success_response.length>0) {
                this.setState({
                  show_process_data: true
                })

              }else{
                this.setState({
                  show_process_data: false
                })
                 
              }
              
              this.fetchTesterData();

            })
            .catch(function (error) {
              
              
          });
          }












          if (this.state.selectedOption.value==="bin_master") {
              console.log(this.state.BinMasters.length);
              console.log(data.length);
            /*if (this.state.BinMasters.length != data.length) {
              alert("Invalid formate");
              let invalidItems = this.state.data.filter(item => !this.validateItem(item))
              console.log(invalidItems);
              return false;
            }*/

            if(invalidItems.length > 0){
              console.log(invalidItems);
              this.setState({
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                showRowDataErrorTester: false,
                showInvalidTesterItem: false,
                showFetchTesterData: false,
                showResponseData: true,
                ErrorRowData: invalidItems,
                showResponseData: false,
                showInvalidItem: false,
                showBaseResponseData: false,
                showInvalidBaseItem: false,
                showInvalidProductItem: false,
                showProductResponseData: false,
                showFetchBaseData: false,
                showFetchProductData: false,
                showFetchBinData: true

              })

              console.log(Object.keys(invalidItems));
             /* alert(indexOfExt(items, invalidItems));*/

              /*return false*/
              this.fetchBinData();
            }

          var arr = []
    
          

          
          for(var i = 0; i < this.state.data.length; i++) {
               // <---- Move declaration inside loop
              
            var orderData  = {};
              orderData['storageType'] = this.state.data[i]['StorageType'];
              orderData['aisle'] = this.state.data[i]['Aisle'];
              orderData['rack'] = this.state.data[i]['Rack'];
              orderData['rackType'] = this.state.data[i]['RackType'];
              orderData['level'] = this.state.data[i]['Level'];
              orderData['binAddress'] = this.state.data[i]['BIN_ID'];
              orderData['binId'] = this.state.data[i]['Bin'];
              orderData['zoneName'] = this.state.data[i]['ZoneName'];
              orderData['zoneNo'] = this.state.data[i]['ZoneNo'];
              orderData['binVolume'] = 4;
			  
			  

              
              
              arr.push(orderData);
          }

          console.log(arr);
          var arr_data = JSON.stringify(arr)


          const payload = {
            arr_data: this.state.data,
            location: this.state.selectedLocation,
            create: false
  };

API.post('/inventory/bin_master/v1/', { param: payload })
            .then((response) =>  {

              console.log(response);
              if (response.data.failure_response.length>0) {
                this.toggleFailed();
              }else{
                this.toggle();
              }

              console.log(response.data.success_response.length);

              if (response.data.success_response.length>0) {
                this.setState({
                  show_process_data: true
                })

              }else{
                this.setState({
                  show_process_data: false
                })
                 
              }
              this.setState({
                showResponseData: true,
                loading: false,
                showInvalidItem: false,
                showBaseResponseData: false,
                showInvalidBaseItem: false,
                showInvalidProductItem: false,
                showProductResponseData: false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataError: false,
                responseFailBinData: response.data,
                responseSuccessBinData: response.data,

              })
              /*this.toggle();
              this.fetchBinData();*/

            })
            .catch(function (error) {
              
              
          });

          }





          
        /*}*/
      });
 
    };
 
    if (rABS) {
      reader.readAsBinaryString(this.state.file);
    } else {
      reader.readAsArrayBuffer(this.state.file);
    };
  }


  processData(){

    this.setState({
      loading: true
    })


    if (this.state.selectedOption.value==="base_pack_zone") {

            

            console.log(this.state.data);
              var arr = []
    
          

          
          for(var i = 0; i < this.state.data.length; i++) {
               // <---- Move declaration inside loop
              
            var orderData  = {};
              orderData['basePackCode'] = this.state.data[i]['BasepackCode'];
              orderData['zoneName'] = this.state.data[i]['ZoneName'];
              orderData['zoneNo'] = this.state.data[i]['ZoneNo'];

              
              arr.push(orderData);
          }

          console.log(arr);
          var arr_data = JSON.stringify(arr)


          const payload = {
            arr_data: this.state.data,
            location: this.state.selectedLocation,
            create: true,
  };

API.post('/inventory/base_pack_zone_code_master/v1/', { param: payload })
            .then((response) =>  {

              console.log(response);
              this.setState({
                showBaseResponseData: true,
                showInvalidBaseItem: false,
                showResponseData: false,
                showInvalidItem: false,
                showProductResponseData: false,
                showTesterResponseData: false,
                showInvalidTesterItem: false,
                showRowDataErrorTester: false,
                showInvalidProductItem: false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                modal: false,
                modalFailed: false,
                loading: false,
                responseFailBaseData: response.data,
                responseSuccessBaseData: response.data,
                successCreatedMessage: 'BasePack Successfully Created',
                ConfirmModal: false,
                Successmodal: true,


              })

              /*alert("BasePack Successfully Created");*/

              
              /*this.toggleFailed();*/
              this.fetchBaseData();

            })
            .catch(function (error) {
              
              
          });
          }


           if (this.state.selectedOption.value==="tester_basepack_master") {

            

           


          const payload = {
            arr_data: this.state.data,
            location: this.state.selectedLocation,
            create: true,
  };

API.post('/inventory/testerBasePackZoneUtility/v1/', { param: payload })
            .then((response) =>  {

              console.log(response);
              this.setState({
                showBaseResponseData: false,
                showTesterResponseData: true,
                showInvalidBaseItem: false,
                showResponseData: false,
                showRowDataErrorTester: false,
                showInvalidTesterItem: false,
                showInvalidItem: false,
                showProductResponseData: false,
                showInvalidProductItem: false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                modal: false,
                modalFailed: false,
                loading: false,
                responseFailBaseData: response.data,
                responseSuccessBaseData: response.data,
                successCreatedMessage: 'Tester BasePack Successfully Created',
                ConfirmModal: false,
                Successmodal: true,


              })

              /*alert("BasePack Successfully Created");*/

              
              /*this.toggleFailed();*/
              this.fetchTesterData();

            })
            .catch(function (error) {
              
              
          });
          }



          



          if (this.state.selectedOption.value==="product_master") {




            console.log(this.state.data);
              var arr = []
    
          

          
          for(var i = 0; i < this.state.data.length; i++) {
               // <---- Move declaration inside loop
              
            var orderData  = {};
              orderData['company'] = this.state.data[i]['Company'];
              orderData['brand'] = this.state.data[i]['Brand'];
              orderData['subBrand'] = this.state.data[i]['Sub Brand'];
              orderData['lbSkuId'] = this.state.data[i]['LB SKU ID'];
              orderData['lbSkuProductName'] = this.state.data[i]['LB SKU Product Name'];
              orderData['basepackCode'] = this.state.data[i]['Basepack Code'];
              orderData['cbuCode'] = this.state.data[i]['CBU Code'];
              orderData['shadeCode'] = this.state.data[i]['Shade Code'];
              orderData['shadeName'] = this.state.data[i]['Shade Name'];
              orderData['category'] = this.state.data[i]['Category'];
              orderData['subCategory'] = this.state.data[i]['Sub-Category'];
              orderData['priceLot'] = this.state.data[i]['Price Lot'];
              orderData['mrp'] = this.state.data[i]['MRP'];
              orderData['uom'] = this.state.data[i]['UOM'];
              orderData['upc'] = this.state.data[i]['UPC'];
              orderData['packSize'] = this.state.data[i]['Pack Size'];
              orderData['packSizeUom'] = this.state.data[i]['Pack Size UOM'];
              orderData['ean'] = this.state.data[i]['EAN'];              
              orderData['icldEAN'] = this.state.data[i]['ICLD EAN'];
			  
              orderData['weight'] = this.state.data[i]['Weight'];
              orderData['volume'] = this.state.data[i]['Volume'];
              orderData['icldVolume'] = this.state.data[i]['ICLD Volume'];
              orderData['sku7Code'] = this.state.data[i]['SKU7 Code'];
              orderData['sku5Code'] = this.state.data[i]['SKU5 Code'];
              orderData['offer'] = this.state.data[i]['Offer'];
              orderData['tester'] = this.state.data[i]['Tester'];
              orderData['storageType'] = this.state.data[i]['Storage Type'];
              orderData['status'] = this.state.data[i]['Status'];
              orderData['createdDateTime'] = this.state.data[i]['Created Date Time'];
              orderData['updatedDateTime'] = this.state.data[i]['Updated Date Time'];

              
              arr.push(orderData);
          }

          console.log(arr);
          var arr_data = JSON.stringify(arr)


          const payload = {
    
            arr_data: this.state.data,
            location: this.state.selectedLocation,
            create: true
  };

API.post('/product/product_master/v1/', { param: payload })
            .then((response) =>  {

              console.log(response);
              this.setState({
                showBaseResponseData: false,
                loading: false,
                showProductResponseData: true,
                showTesterResponseData: false,
                showRowDataErrorTester:  false,
                showInvalidTesterItem: false,
                showInvalidBaseItem: false,
                showResponseData: false,
                showInvalidItem: false,
                showInvalidProductItem:false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                modalFailed: false,
                modal: false,
                responseFailProductData: response.data,
                responseSuccessProductData: response.data,
                successCreatedMessage: 'Product Master Successfully Created',
                ConfirmModal: false,
                Successmodal: true,
                
              })
              /*alert("Product Master Successfully Created");*/
              /*this.toggle();*/
             /* this.toggleFailed();*/
              this.fetchProductData();

            })
            .catch(function (error) {
              
              
          });


              
          }


          if (this.state.selectedOption.value==="bin_master") {
              /*console.log(this.state.BinMasters.length);
              console.log(data.length);*/
            /*if (this.state.BinMasters.length != data.length) {
              alert("Invalid formate");
              let invalidItems = this.state.data.filter(item => !this.validateItem(item))
              console.log(invalidItems);
              return false;
            }*/

            

          var arr = []
    
          

          
          for(var i = 0; i < this.state.data.length; i++) {
               // <---- Move declaration inside loop
              
            var orderData  = {};
              orderData['storageType'] = this.state.data[i]['StorageType'];
              orderData['aisle'] = this.state.data[i]['Aisle'];
              orderData['rack'] = this.state.data[i]['Rack'];
              orderData['rackType'] = this.state.data[i]['RackType'];
              orderData['level'] = this.state.data[i]['Level'];
              orderData['binAddress'] = this.state.data[i]['BIN_ID'];
              orderData['binId'] = this.state.data[i]['Bin'];
              orderData['zoneName'] = this.state.data[i]['ZoneName'];
              orderData['zoneNo'] = this.state.data[i]['ZoneNo'];
              orderData['binVolume'] = 4;

              
              
              arr.push(orderData);
          }

          console.log(arr);
          var arr_data = JSON.stringify(arr)


          const payload = {
            arr_data: this.state.data,
            location: this.state.selectedLocation,
            create: true
  };

API.post('/inventory/bin_master/v1/', { param: payload })
            .then((response) =>  {

              console.log(response);
              
              this.setState({
                showResponseData: true,
                showInvalidItem: false,
                loading: false,
                showBaseResponseData: false,
                showTesterResponseData: false,
                showRowDataErrorTester: false,
                showInvalidTesterItem: false,
                showInvalidBaseItem: false,
                showInvalidProductItem: false,
                showProductResponseData: false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataError: false,
                modalFailed: false,
                modal: false,
                responseFailBinData: response.data,
                responseSuccessBinData: response.data,
                successCreatedMessage: 'Bin Master Successfully Created',
                ConfirmModal: false,
                Successmodal: true,

              })
             /* this.toggle();*/
              
              /*this.toggleFailed();*/
              /*alert("Bin Master Successfully Created");*/
              this.fetchBinData();

            })
            .catch(function (error) {
              
              
          });

          }


         /* this.toggleFailed();*/


  }


 

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    console.log(this.state.showInvalidItem)
    const { selectedOption } = this.state;
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { Successmodal } = this.state;
    const { ConfirmModal } = this.state;


    const data = {

      columns: [
        {

          label:'Basepack Code',

          field:'base_pack_code',
          sort: 'asc',
          width: 150

        },

        {

          label:'Basepack Desc',

          field:'base_pack_desc',
          sort: 'asc',
          width: 150

        },

        {

          label:'Category',

          field:'category',
          sort: 'asc',
          width: 150

        },

        {

          label:'Storage Type',

          field:'storage_type',
          sort: 'asc',
          width: 150

        },

        {

          label:'Shade Applicable',

          field:'shade_applicable',
          sort: 'asc',
          width: 150

        },

        {

          label:'Shade Code',

          field:'shade_code',
          sort: 'asc',
          width: 150

        },

        {

          label:'Shade Name',

          field:'shade_name',
          sort: 'asc',
          width: 150

        },

        {

          label:'Company',

          field:'company',
          sort: 'asc',
          width: 150

        },

        {

          label:'Brand',

          field:'brand',
          sort: 'asc',
          width: 150

        },

        {

          label:'Sub Brand',

          field:'sub_brand',
          sort: 'asc',
          width: 150

        },

        {

          label:'Fast Moving',

          field:'fast_moving',
          sort: 'asc',
          width: 150

        },

        {

          label:'Shelf Life',

          field:'shelf_life',
          sort: 'asc',
          width: 150

        },

        {

          label:'Barcode Type',

          field:'barcode_type',
          sort: 'asc',
          width: 150

        },

        {

          label:'OCLD Flag',

          field:'ocld_flag',
          sort: 'asc',
          width: 150

        },

        {

          label:'Added On',

          field:'added_on',
          sort: 'asc',
          width: 150

        },
        {

          label:'Updated On',

          field:'updated_on',
          sort: 'asc',
          width: 150

        },{

          label:'Created By',

          field:'created_by',
          sort: 'asc',
          width: 150

        },
        {

          label:'Updated By',

          field:'updated_by',
          sort: 'asc',
          width: 150

        },
        {

          label:'OCLD Flag Updated time',

          field:'ocld_flag_update_time',
          sort: 'asc',
          width: 220

        },
        {

          label:'Invoicing Shelf Life',

          field:'invoicing_shelf_life',
          sort: 'asc',
          width: 220

        },
        
         

        

      ],

      rows:this.state.tableRows,

    }


    const baseData = {

      columns: [

        {

          label:'Base Pack Code',

          field:'base_pack_code',

        },

        {

          label:'zoneName',

          field:'zone_name',

        },

        {

          label:'zoneNumber',

          field:'zone_number',

        },
        {

          label:'Product Type',

          field:'productType',

        },


      ],

      rows:this.state.tableRowsBase,

    }



    const productData = {

      columns: [

        {

          label:'Company',

          field:'company',
          width: 130

        },

        {

          label:'Brand',

          field:'brand',
          width: 130

        },

        {

          label:'Sub Brand',

          field:'sub_brand',
          width: 150

        },

        {

          label:'IB Sku Id',

          field:'ib_sku_id',
          width: 150

        },

        {

          label:'IB Sku Product Name',

          field:'ib_sku_product_name',
          width: 270

        },

        {

          label:'Base Pack Code',

          field:'base_pack_code',
          width: 130

        },

        {

          label:'CBU Code',

          field:'cbu_code',
          width: 130

        },

        {

          label:'Shade Code',

          field:'shade_code',
          width: 130

        },

        {

          label:'Shade Name',

          field:'shade_name',
          width: 170
        },

        {

          label:'Category',

          field:'category',
          width: 180

        },

        {

          label:'Sub-Category',

          field:'sub_category',
          width: 180

        },

        {

          label:'Price Lot',

          field:'price_lot',
          width: 180
        },

        {

          label:'MRP',
          field:'mrp',
          width: 150

        },

        {
          label:'UOM',
          field:'uom',
          width: 150
        },
        {

          label:'UPC',
          field:'upc',
          width: 150
        },

        {
          label:'Pack Size',
          field:'pack_size',
          width: 180
        },

        {

          label:'Pack Size UO',

          field:'pack_size_uo',
          width: 150

        },

        {

          label:'EAN',

          field:'ean',
          width: 150

        },

        {

          label:'ICLD EAN',

          field:'icld_ean',
          width: 150

        },
		
		{

          label:'Product Length',

          field:'product_length',
          width: 150

        },
		{

          label:'Product Breadth',

          field:'product_breadth',
          width: 150

        },
		{

          label:'Product Height',

          field:'product_height',
          width: 150

        },

        {

          label:'Weight',

          field:'weight',
          width: 180

        },

        {

          label:'Volume',

          field:'volume',
          width: 150

        },

        {

          label:'ICLD Volume',

          field:'icldVolume',
          width: 150

        },

        {

          label:'SKU7 Code',

          field:'sku7Code',
          width: 180

        },

        {

          label:'SKU5 Code',

          field:'sku5Code',
          width: 180

        },

        {

          label:'Offer',

          field:'offer',
          width: 180

        },

        {

          label:'Tester',

          field:'tester',
          width: 150

        },

        {

          label:'Storage Type',

          field:'storageType',
          width: 150

        },

        {

          label:'Status',

          field:'status',
          width: 150

        },

        {

          label:'Created Date Time',

          field:'createdDateTime',
          width: 180

        },

        {

          label:'Outer Carton EAN',

          field:'outerCartonEAN',
          width: 180

        },
        {

          label:'CPO',

          field:'cpo',
          width: 180

        },
        {

          label:'Carton Length',

          field:'cartonLength',
          width: 180

        },
        {

          label:'Carton Breadth',

          field:'cartonBreadth',
          width: 180

        },
        {

          label:'Carton Height',

          field:'cartonHeight',
          width: 180

        },
        {

          label:'Carton Volumne',

          field:'cartonVolume',
          width: 180

        },
        {

          label:'OCLD Applicable',

          field:'ocldApplicable',
          width: 180

        },

      ],

      rows:this.state.tableRowsProduct,

    }



    const testerData = {

      columns: [

        {

          label:'BasePack Code',

          field:'base_pack_code',
          sort: 'asc',

        },

        

        
        {

          label:'Bin Address',

          field:'bin',
           sort: 'asc',

        },



      ],

      rows:this.state.tableRowsTester,

    }







    return (
      <Col xl={12}>
	  {this.state.loading_overlay && <LoadingOverlay active={true} spinner text='' /> }
        <Card>
          

          {
            this.state.showRowDataError  && (
                <CardBody style={{marginTop: 20}}>
                  <div>
                    <h4 style={{color: 'red', fontWeight: 'bold'}} className="subhead red-text"> Please upload file again. </h4>
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>BIN ID</th>
                        <th>Reason</th>
                        
                      </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.ErrorRowData.length>0 && (
                      this.state.ErrorRowData.map((item, index) => (
                        <tr>
                          <td>{item['Bin']}</td>
                          <td style={{color:'red'}}> Column is missing </td>
                                           
                          
                        </tr>
                      )))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }




          {
            this.state.showInvalidItem  && (
                <CardBody style={{marginTop: 20}}>
                  <div>
                  {this.state.show_process_data &&
                    <h4 style={{color: 'red', fontWeight: 'bold'}} className="subhead red-text">
                      <Button style={{backgroundColor: '#24d6a3', color: '#fff', marginLeft: 12}} className="modal_ok show_bin_proceed"  onClick={this.openConfirm}>

                        {this.state.loading && 
                          <i
                            className="fa fa-refresh fa-spin"
                            style={{ marginRight: "5px" }}
                          />
                        }
                      Proceed</Button>
                     </h4>
                  }
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>BIN ID</th>
                        <th>Response</th>
                        
                        
                      </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.responseFailBinData.failure_response.length>0 && (
                      this.state.responseFailBinData.failure_response.map((item, index) => (
                        <tr>
                          <td>{item.bin_address}</td>
                          <td style={{color: 'red'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }

                    {
                      this.state.responseSuccessBinData.success_response.length>0 && (
                      this.state.responseSuccessBinData.success_response.map((item, index) => (
                        <tr>
                          <td>{item.bin_address}</td>
                          <td style={{color: 'green'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }

          {
            this.state.showFetchBinData  && (

          <CardBody style={{marginTop: 20}}>
            <div className="table_header" style={{borderBottomWidth:'0px'}}>
              
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">Basepack Master</h4>
              
			  <span
                    className="pull-right"
                    onClick={() => exportToCSV(this.state.filtered_orderData, "BasePack Master")}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>

            </div>
			<hr style={{marginTop:'30px',marginBottom:'0px'}}/>
            
          <MDBDataTable
                  scrollX
                  scrollY
                  onSearch={this.filterData}
                  sortable={false}
                  displayEntries={false}
                  striped
                  bordered
                  data={data}
                />
          </CardBody>

          )}



          {
            this.state.showRowDataErrorBase  && (
                <CardBody style={{marginTop: 20}}>
                  <div>
                    <h4 style={{color: 'red', fontWeight: 'bold'}} className="subhead red-text">Please upload file again </h4>
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>Base Pack Code</th>
                        <th>Reason</th>
                        
                      </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.ErrorRowData.length>0 && (
                      this.state.ErrorRowData.map((item, index) => (
                        <tr>
                          <td>{item['Basepack Code']}</td>
                          <td style={{color:'red'}}> Column is missing </td>
                                           
                          
                        </tr>
                      )))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }




          {
            this.state.showInvalidBaseItem  && (
                <CardBody style={{marginTop: 20}}>
                  <div>
                  {this.state.show_process_data &&
                    <h4 style={{color: 'red', fontWeight: 'bold'}} className="subhead red-text"> <Button style={{backgroundColor: '#24d6a3', color: '#fff', marginLeft: 12}} className="modal_ok"  onClick={this.openConfirm}>
                      {this.state.loading && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }

                    Proceed</Button> </h4>
                  }
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>Base Pack Code</th>
                        <th>Response</th>
                        
                        
                      </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.responseFailBaseData.failure_response.length>0 && (
                      this.state.responseFailBaseData.failure_response.map((item, index) => (
                        <tr>
                          <td>{item.basePackCode}</td>
                          <td style={{color: 'red'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }

                    {
                      this.state.responseSuccessBaseData.success_response.length>0 && (
                      this.state.responseSuccessBaseData.success_response.map((item, index) => (
                        <tr>
                          <td>{item.basePackCode}</td>
                          <td style={{color: 'green'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }



                    </tbody>
                  </Table>
                </CardBody>
            )
          }

          {
            this.state.showFetchBaseData  && (

          <CardBody style={{marginTop: 20}}>
            <div className="table_header" style={{borderBottomWidth:'0px'}}>
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text"> Basepack Zone Master</h4>
			  <span
                    className="pull-right"
                    onClick={() => exportToCSV(this.state.postsBase, "BasepackMaster")}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>

            </div>
			<hr style={{marginTop:'30px',marginBottom:'0px'}}/>
            <MDBDataTable
            striped
            bordered
            hover
            data={baseData}
          />
          </CardBody>

          )}



          {
            this.state.showRowDataErrorProduct  && (
                <CardBody style={{marginTop: 20}}>
                  <div>
                    <h4 style={{color: 'red', fontWeight: 'bold'}} className="subhead red-text"> Please upload file again </h4>
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>LB SKU ID</th>
                        <th>Reason</th>
                        
                      </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.ErrorRowData.length>0 && (
                      this.state.ErrorRowData.map((item, index) => (
                        <tr>
                          <td>{item['LB SKU ID']}</td>
                          <td style={{color:'red'}}> Column is missing </td>
                                           
                          
                        </tr>
                      )))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }




          {
            this.state.showInvalidProductItem  && (
                <CardBody style={{marginTop: 20}}>
                  <div>
                  {this.state.show_process_data &&
                    <h4 style={{color: 'red', fontWeight: 'bold'}} className="subhead red-text">
                      <Button style={{backgroundColor: '#24d6a3', color: '#fff', marginLeft: 12}} className="modal_ok"  onClick={this.openConfirm}>
                        {this.state.loading && 
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      }
                      Proceed</Button> 
                     </h4>
                    }
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>LB SKU ID</th>
                        <th>Response</th>
                        
                        
                      </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.responseFailProductData.failure_response.length>0 && (
                      this.state.responseFailProductData.failure_response.map((item, index) => (
                        <tr>
                          <td>{item.lb_sku_id}</td>
                          <td style={{color: 'red'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }

                    {
                      this.state.responseSuccessProductData.success_response.length>0 && (
                      this.state.responseSuccessProductData.success_response.map((item, index) => (
                        <tr>
                          <td>{item.lb_sku_id}</td>
                          <td style={{color: 'green'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }

          {
            this.state.showFetchProductData  && productData &&(

          <CardBody style={{marginTop: 20}}>
            <div className="table_header" style={{borderBottomWidth:'0px'}}>
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text"> Product Master</h4>
              
			<span
                    className="pull-right"
                    onClick={() => exportToCSV(this.state.tableRowsProduct, "ProductMaster")}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>

            </div>
			<hr style={{marginTop:'30px',marginBottom:'0px'}}/>

             {this.state.loadingGRNData && 
                <div style={{width: '2300%', textAlign: 'center', paddingTop: 22}}>
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" , fontSize: 18 }}
                      />
                  </div>
              }
            
         <MDBDataTable
            scrollX
            striped
            bordered
            data={productData}
          />

          </CardBody>

          )}





          {
            this.state.showRowDataErrorTester  && (
                <CardBody style={{marginTop: 20}}>
                  <div>
                    <h4 style={{color: 'red', fontWeight: 'bold'}} className="subhead red-text"> Please upload file again </h4>
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>LB SKU ID</th>
                        <th>Reason</th>
                        
                      </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.ErrorRowData.length>0 && (
                      this.state.ErrorRowData.map((item, index) => (
                        <tr>
                          <td>{item['LB SKU ID']}</td>
                          <td style={{color:'red'}}> Column is missing </td>
                                           
                          
                        </tr>
                      )))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }




          {
            this.state.showInvalidTesterItem  && (
                <CardBody style={{marginTop: 20}}>
                  <div>
                  {this.state.show_process_data &&
                    <h4 style={{color: 'red', fontWeight: 'bold'}} className="subhead red-text">
                      <Button style={{backgroundColor: '#24d6a3', color: '#fff', marginLeft: 12}} className="modal_ok"  onClick={this.openConfirm}>
                        {this.state.loading && 
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      }
                      Proceed</Button> 
                     </h4>
                    }
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>LB SKU ID</th>
                        <th>Response</th>
                        
                        
                      </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.responseFailTesterData.failure_response.length>0 && (
                      this.state.responseFailTesterData.failure_response.map((item, index) => (
                        <tr>
                          <td>{item.basePackCode}</td>
                          <td style={{color: 'red'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }

                    {
                      this.state.responseSuccessTesterData.success_response.length>0 && (
                      this.state.responseSuccessTesterData.success_response.map((item, index) => (
                        <tr>
                          <td>{item.basePackCode}</td>
                          <td style={{color: 'green'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }

         
		 {
            this.state.showFetchTesterData  && productData &&(

          <CardBody style={{marginTop: 20}}>
            <div className="table_header" style={{borderBottomWidth:'0px'}}>
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text"> Tester Basepack Master</h4>
             
			<span
                    className="pull-right"
                    onClick={() => exportToCSV(this.state.postsTester, "TesterFile")}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>

            </div>
			<hr style={{marginTop:'30px',marginBottom:'0px'}}/>

             {this.state.loadingGRNData && 
                <div style={{width: '2300%', textAlign: 'center', paddingTop: 22}}>
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" , fontSize: 18 }}
                      />
                  </div>
              }
            
         <MDBDataTable
            scrollX
            striped
            bordered
            data={testerData}
          />

          </CardBody>

          )}









        </Card>
        <Modal
          isOpen={modal}
          toggle={this.toggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4>Successfully Validated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.togglePressCancel}>Ok</Button>
          </ButtonToolbar>
        </Modal>


        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}

          style={{maxWidth: 578}}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggleFailed} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4>This file contains some errors. </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#ddd', color: '#fff'}} className="modal_ok"  onClick={this.togglePressCancel}>Cancel</Button>
            
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={Successmodal}
          toggle={this.Successtoggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.Successtoggle} />
           
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4>{this.state.successCreatedMessage}</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.SuccesstoggleCancel}>Ok</Button>
          </ButtonToolbar>
        </Modal>


        <Modal
          isOpen={ConfirmModal}
          toggle={this.ConfirmToggle}
          style={{maxWidth: 456}}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.ConfirmToggle} />
           
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4 style={{fontSize: 18}}> Are you sure you want to proceed?</h4>
            <br/>
            <h3 style={{fontSize: 17}}><strong> NOTE: </strong> Duplicate entries will be updated if you proceed. </h3>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff' , marginRight: 8}} className="modal_ok"  onClick={this.processData}>Ok</Button>
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.ConfirmToggle}>Cancel</Button>
          </ButtonToolbar>
        </Modal>





      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));